<div class="mb-6">
    @if (loadingCensurasPublicas()) {
        <div class="text-color-secondary text-sm mb-2">Carregando censuras públicas...</div>
    }
    @if (!loadingCensurasPublicas() && erroCensurasPublicas()) {
        <div class="text-red-500 text-sm mb-2">
            {{ erroCensurasPublicas() }}
        </div>
    }

    <p-table [value]="censuras()" styleClass="p-datatable-sm w-full" [tableStyle]="{ width: '100%' }" stripedRows fluid>
        <ng-template pTemplate="header">
            <tr>
                <th class="text-sm">Data Início</th>
                <th class="text-sm">Data Final</th>
                <th class="text-sm">Observações</th>
                <th class="text-sm text-center">Anexo</th>
                @if (modoEdicao()) {
                    <th class="text-sm text-center">Ações</th>
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td class="text-sm">{{ row.dtInicio }}</td>
                <td class="text-sm">{{ row.dtFim }}</td>
                <td class="text-sm">{{ row.observacao }}</td>
                <td class="text-center">
                    <p-button icon="pi pi-eye" severity="info" [text]="true" [rounded]="true" [disabled]="!row.possuiAnexo" (onClick)="visualizar.emit(row)"></p-button>
                </td>
                @if (modoEdicao()) {
                    <td class="text-center">
                        <p-button
                            icon="pi pi-pencil"
                            severity="info"
                            [text]="true"
                            [rounded]="true"
                            [appCan]="roleEditar()"
                            [appCanUf]="uf()"
                            [disabled]="salvandoCensuraPublica()"
                            (onClick)="editar.emit(row)"
                        ></p-button>
                    </td>
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="modoEdicao() ? 5 : 4" class="text-center">
                    <div class="table-empty-state">
                        <span class="table-empty-state-icon"><i class="pi pi-search"></i></span>
                        <p class="table-empty-state-title">Nenhuma censura pública cadastrada.</p>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
